// Wizard questions answered with several fixed values. Each is stored on Lead as
// an enum list and labelled only where it is shown, so a request can never put
// free text in front of a partner.
//
// No Prisma client import, so both server code and "use client" components can
// import this.

import type { LeadCallTime, LeadTimeSlot } from "@/generated/prisma/enums";

// Key order of `labels` is the option and render order.
function listAnswer<T extends string>(labels: Record<T, string>) {
  const options = (Object.keys(labels) as T[]).map((value) => ({ value, label: labels[value] }));
  const labelsOf = (selected: readonly T[]) =>
    options.filter((o) => selected.includes(o.value)).map((o) => o.label);
  return {
    options,
    // In option order; anything not offered is dropped.
    parse(values: unknown): T[] {
      if (!Array.isArray(values)) return [];
      return options.map((o) => o.value).filter((value) => values.includes(value));
    },
    labels: labelsOf,
    humanize(selected: readonly T[]): string | null {
      return labelsOf(selected).join(", ") || null;
    },
  };
}

// Erhverv: when the firm may come. Decides whether a company can take the job.
export const TIME_SLOTS = listAnswer<LeadTimeSlot>({
  UDEN_AABNINGSTID: "Uden for åbningstid",
  DAG: "Dag (08–16)",
  AFTEN: "Aften (16–22)",
  WEEKEND: "Weekend",
  FLEKSIBEL: "Fleksibel",
});

// Privat: when the customer can best take the partner's call.
export const CALL_TIMES = listAnswer<LeadCallTime>({
  FORMIDDAG: "Formiddag (8–12)",
  EFTERMIDDAG: "Eftermiddag (12–17)",
  AFTEN: "Aften (17–20)",
  NAAR_SOM_HELST: "Når som helst",
});
